<template>
    <div class="sidebarMenuItem">
        <router-link :to="route">
            <div :title="title" class="sidebar-icon" :class="activeClass">
                <i class="material-icons md-white">{{icon}}</i>
            </div>
        </router-link>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'sideBarMenuItem',
    mixins: [
        Default
    ],
    props: ['title', 'icon', 'route'],
    data() {
        return {
            activeClass: ''
        };
    },
    watch: {
        $route: function(newVal, oldVal) {
            this.updateActiveClass();
        }
    },
    mounted() {
        this.updateActiveClass();
    },
    methods: {
        updateActiveClass: function() {
            const routesWithChildren = this.$router.options.routes[0].children.filter((route) => route.children ? route.children.length > 0 : false);
                
            // Check if current routes has children
            // -if so: only match the beginning of the current route to the route prop
            // -else: complete route must match route prop
            if (routesWithChildren.filter((route) => route.name === this.route.name).length > 0)
                this.activeClass = this.$route.path.indexOf(this.route.path) !== -1 ? 'active' : '';
            else
                this.activeClass = this.$route.path === this.route.path ? 'active' : '';
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .sidebarMenuItem {
        padding-bottom: 2em;

        .sidebar-icon {
            height: 3em;

            /*$active-color: #6b6e73;*/
            $active-color: $primary-color;
            &:hover {
                background-color: $active-color;
                transition: background-color 0.1s;
            }

            &.active {
                background-color: $active-color;
            }

            .material-icons {
                margin: .5em;
            }
        }
    }
</style>
